import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponseHandlerService } from "./httpResponseHandler.service";
import { AppConstants } from "../app.constants";
import { catchError, map } from "rxjs/operators";
import { AuthenticatedHttp } from "./http.service";
import { HttpModel } from "../models/http.model";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable()
export class MailService {

  constructor(private authHttp: AuthenticatedHttp, private http: HttpClient, private httpResponseHandlerService: HttpResponseHandlerService) {
  }

  sendPasswordReset(userName: string): Observable<boolean> {
    return this.authHttp.post<HttpModel>(AppConstants.SEND_MAIL, {
      keyMail: "password_reset",
      userName: userName.trim()
    })
      .pipe(
        map((response) => this.httpResponseHandlerService.handlePostResponse(response, true)),
        catchError((error) => this.httpResponseHandlerService.handleError(error, true))
      );
  }
}
